import { IDynamicSearchableQueryOptions } from "@timesheets/webapp-support";
import { mergeQueryOptions } from "@gemma/querying";

export function getDefaultMergedDynamicQueryOptions<
  //
  TFilter,
  TDynamicQueryOptions extends IDynamicSearchableQueryOptions<TFilter> = IDynamicSearchableQueryOptions<TFilter>
>(dynamicQueryOptions: TDynamicQueryOptions): TDynamicQueryOptions {
  const options = mergeQueryOptions<TDynamicQueryOptions, unknown, TDynamicQueryOptions>(dynamicQueryOptions, {
    //
    groupBy: null,
    filter: {},
    page: { index: 0 },
    readonly: {},
    sort: [],
    search: null,
  });

  return options.merged;
}
